// Visas i dokumentvyer som öppnats från guidningen, så användaren hittar tillbaka.
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const JourneyReturnBar: React.FC = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  if (params.get("from") !== "guidning") return null;

  const step = params.get("gstep");
  const total = params.get("gtot");
  const label =
    step && total ? `Tillbaka till guidningen (steg ${step} av ${total})` : "Tillbaka till guidningen";

  return (
    <div className="container mx-auto px-4 pt-3">
      <Link
        to="/guidning"
        className="inline-flex min-h-11 items-center gap-2 rounded-lg border border-on-hero/25 bg-on-hero/10 px-3 py-2 text-sm font-medium text-on-hero hover:bg-on-hero/15"
      >
        <ArrowLeft className="h-4 w-4" aria-hidden="true" />
        {label}
      </Link>
    </div>
  );
};

export default JourneyReturnBar;
